/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerGetScreenbugByDateQueryResponse, PntAppControllerGetScreenbugByDatePathParams, PntAppControllerGetScreenbugByDateQueryParams } from "../models/PntAppControllerGetScreenbugByDate";

export function getPntAppControllerGetScreenbugByDateUrl(slug: PntAppControllerGetScreenbugByDatePathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/screenbug` as const }
  return res
}

/**
 * @summary Retrieve the screenbugs for a given time range
 * {@link /pnt/v2/segments/:slug/screenbug}
 */
export async function pntAppControllerGetScreenbugByDate(slug: PntAppControllerGetScreenbugByDatePathParams["slug"], params: PntAppControllerGetScreenbugByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntAppControllerGetScreenbugByDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntAppControllerGetScreenbugByDateUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}